<template>
  <form @submit.prevent="onSubmit" class="shipping-service-form">
    <AppField
      label="Código"
      required
      :state="errors.code === null ? null : !errors.code"
      :invalidFeedback="errors.code || 'Identificador único (ej: extra_large_a)'">
      <AppInput
        v-model="form.code"
        placeholder="extra_large_a"
        maxlength="30" />
    </AppField>

    <AppField
      label="Nombre"
      required
      :state="errors.name === null ? null : !errors.name"
      :invalidFeedback="errors.name">
      <AppInput
        v-model="form.name"
        placeholder="Extra grande A"
        maxlength="80" />
    </AppField>

    <AppField
      label="Orden"
      description="Define el orden en que aparece el servicio en listados (menor = primero).">
      <AppInput
        type="number"
        v-model.number="form.order"
        placeholder="0" />
    </AppField>

    <AppField v-if="editMode" label="Activo">
      <AppCheckbox v-model="form.active">
        Servicio disponible
      </AppCheckbox>
    </AppField>

    <div v-if="submitError" class="shipping-service-form__alert">
      {{ submitError }}
    </div>

    <div class="shipping-service-form__actions">
      <AppButton outline type="button" @click="$emit('cancel')">
        Cancelar
      </AppButton>
      <AppButton type="submit" :disabled="loading">
        <span v-if="loading">Guardando...</span>
        <span v-else>{{ editMode ? 'Actualizar' : 'Crear' }}</span>
      </AppButton>
    </div>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import AppField from '../UI/AppField.vue'
import AppInput from '../UI/AppInput.vue'
import AppButton from '../UI/AppButton.vue'
import AppCheckbox from '../UI/AppCheckbox.vue'

export default {
  name: 'ShippingServiceForm',
  components: { AppField, AppInput, AppButton, AppCheckbox },
  props: {
    service: {
      type: Object,
      default: null
    },
    editMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const baseCode = this.editMode && this.service ? this.service.code : ''
    const baseName = this.editMode && this.service ? this.service.name : ''
    const baseOrder = this.editMode && this.service ? this.service.order : 0
    const baseActive = this.editMode && this.service ? this.service.active : true

    return {
      form: {
        code: baseCode,
        name: baseName,
        order: baseOrder,
        active: baseActive
      },
      errors: {
        code: null,
        name: null
      },
      submitError: '',
      loading: false
    }
  },
  methods: {
    ...mapActions(['createShippingService', 'updateShippingService']),
    validate () {
      this.errors.code = null
      this.errors.name = null

      if (!this.form.code || !this.form.code.trim()) {
        this.errors.code = 'El código es requerido'
      } else if (this.form.code.length > 30) {
        this.errors.code = 'Máximo 30 caracteres'
      }

      if (!this.form.name || !this.form.name.trim()) {
        this.errors.name = 'El nombre es requerido'
      } else if (this.form.name.length > 80) {
        this.errors.name = 'Máximo 80 caracteres'
      }

      return !this.errors.code && !this.errors.name
    },
    async onSubmit () {
      this.submitError = ''
      if (!this.validate()) return

      this.loading = true
      try {
        const payload = {
          code: this.form.code,
          name: this.form.name.trim(),
          order: Number(this.form.order) || 0
        }
        if (this.editMode) payload.active = !!this.form.active

        let response
        if (this.editMode) {
          response = await this.updateShippingService({ id: this.service.id, ...payload })
        } else {
          response = await this.createShippingService(payload)
        }

        if (response && (response.status === 200 || response.status === 201)) {
          this.$emit('submit', response.data)
        } else if (response && response.data && response.data.error) {
          this.submitError = response.data.error
        } else {
          this.submitError = 'No se pudo guardar el servicio'
        }
      } catch (err) {
        this.submitError = (err && err.response && err.response.data && err.response.data.error)
          || (err && err.message)
          || 'Error inesperado'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.shipping-service-form {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.shipping-service-form__actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1rem;
}

.shipping-service-form__alert {
  margin-top: 0.5rem;
  padding: 0.5rem 0.75rem;
  background: #fee2e2;
  color: #991b1b;
  border-radius: 4px;
  font-size: 0.875rem;
}
</style>